/**
 * Created by Jaime Bonilla Venegas on 2017-06-13.
 *
 * contentStyle={{ width: '75%', maxWidth: 'none' }}
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SortDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import IconButton from 'material-ui/IconButton';
import { List } from '../../components/data-containers';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader, EmptyList } from '../../components/layout';
import { ConceptosFilter } from '../../components/filters';
import { serializeParams } from '../../common/helpers';
import Snackbar from 'material-ui/Snackbar';
import { getPagePermissions, INVOICE_ITEM_PERMISSION } from '../../security/permissions';

class Conceptos extends Component {

    componentWillMount() {
        this.props.fetchData('invoiceItems', 'invoiceItems', 'invoiceItems?projection=forListing&sort=concept');
    }

    CreateURL(table, filter, projection) {

        var res = filter.split("%2C");
        var flag = false;

        var urltoCall = "";
        res.forEach(function (value, index, array) {

            if (flag) {
                urltoCall = urltoCall + "&applicable=" + value;
                console.log("entro");
            }
            if (index == 0) {
                urltoCall = urltoCall + value
                flag = true;
            }

        });

        return (table.concat(urltoCall).concat(projection));
    }

    formHandler(open, path, form) {
        this.props.notify({ op: 'update', path: 'formOpen', value: open });

        switch (path) {
            case 'NEW_INVOICE_ITEM':
                this.props.saveInvoiceItem(form);
                break;
            default:
        }
    }

    render() {
        const { formOpen, notify, customers, invoiceItems, filterinvoice = [], showNotification, showMessage, notificationColor, pagePermissions, numPages, activePage, isLoading } = this.props;
        const styles = {
            smallIcon: {
                width: 23,
                height: 23,
            },
            small: {
                width: 23,
                height: 23,
                padding: 0,
                verticalAlign: -16,
            },
        };

        return (
            <div>
                <SubHeader
                    title="Conceptos de Facturacion"
                    showRefresh={isLoading}
                    onPressHeaderButton={() => this.formHandler(true, 'formOpen')}
                    showAddButton={pagePermissions.create}
                    paginationConfig={{
                        numPages,
                        activePage,
                        notify: (page) => {
                            this.props.fetchData('invoiceItems', 'invoiceItems', 'invoiceItems',  {projection: 'forListing' ,sort: 'concept' , page} );
                            //fetchData('customers', 'customers', 'customers', { projection: 'denormalizedCustomer', sort: 'name', page, ['executiveUser.id']: isExecutive() ? userId : '' });
                        }
                    }}
                />
                <div className="navbar visible-xs" style={{ padding: '0rem 2.3rem' }}>
                    <button
                        className="btn btn-default navbar-btn btn-filtros"
                        data-toggle="collapse"
                        data-target="#filter-sidebar"
                    >
                        <i className="fa fa-tasks" /> Panel de filtros
                    </button>
                </div>
                <div>
                    <ConceptosFilter
                        onSearch={(params) => {
                            Object.keys(params).forEach(key => params[key] === "" ? delete params[key] : '');
                            this.props.fetchData('invoiceItems', 'invoiceItems', this.CreateURL('invoiceItems', serializeParams(params), '&projection=forListing&sort=concept'))
                        }}
                        onClear={(params) => {
                            this.props.fetchData('invoiceItems', 'invoiceItems', 'invoiceItems?projection=forListing&sort=concept');
                        }}
                        isEmpty={invoiceItems.length === 0}
                    >
                        {
                            invoiceItems.length === 0 ? <EmptyList /> :
                                invoiceItems.map((invoiceItem, index) => {
                                    return (
                                        <Item
                                            key={index}
                                            invoiceItem={invoiceItem}
                                            allowUpdate={pagePermissions.update}
                                            allowDelete={pagePermissions.delete}
                                            actions={{
                                                deleteInvoiceItem: (value) => {
                                                    this.props.deleteInvoiceItem(value, index);
                                                }
                                            }}
                                            onSave={(newInvoiceItem) => {
                                                //This is only updating the item on memory
                                                //Replace this with the action that saves results on server
                                                this.props.editInvoiceItem(newInvoiceItem, index);
                                            }}
                                        />
                                    );
                                })
                        }
                    </ConceptosFilter>
                </div>
                <Form
                    title="Nuevo Concepto"
                    type="concepto"
                    open={formOpen}
                    actions={{}}
                    onModalClosed={() => this.formHandler(false, 'formOpen')}
                    onSave={(form) => {
                        this.formHandler(false, 'NEW_INVOICE_ITEM', form);
                    }}//Will return if form is valid to send it
                />

                <Snackbar
                    bodyStyle={{
                        top: 0,
                        bottom: 'auto',
                        backgroundColor: notificationColor,
                        maxWidth: "800px",
                        height: "55px",
                        lineHeight: "28px",
                        left: (window.innerWidth - 288) / 2,
                        /*transform: this.props.errorMessage ?
                          'translate3d(0, 0, 0)' :
                          "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
                    }}
                    open={showNotification}
                    message={showMessage}
                    autoHideDuration={4000}
                    onRequestClose={() => this.props.notify({ op: 'update', path: 'showNotification', value: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ conceptos, userData, userData: { permissions } }) => {
    return {
        ...conceptos,
        userData,
        pagePermissions: getPagePermissions(INVOICE_ITEM_PERMISSION, permissions)
    };
};

export default connect(mapStateToProps, { ...actions })(Conceptos);



// WEBPACK FOOTER //
// ./containers/conceptos/index.js